<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('PrintBroductBarcode')"
      :active.sync="isSidebarActiveLocal"
      @close="closePrintPopup"
      @cancel="closePrintPopup"
      fullscreen
    >
      <b-row>
        <b-col lg="4" v-if="templates">
          <b-row>
            <component
              :is="scrollbarTag"
              ref="scroll2"
              class="vs-input--label scroll-area--data-list-add-new"
              :settings="settings"
              :key="$vs.rtl"
            >
              <b-row style="padding-right: 8px">
                <b-col
                  lg="6"
                  style="padding-right: 2px"
                  v-for="(temp, ind) in templates"
                  :key="temp.TemplateDefinitionId"
                  v-on:click="
                    getSelectedTemplate(temp, ind);
                    getSelectedStockWithBarcode();
                  "
                >
                  <vs-card :class="temp.isSelected == 'selected' ? 'bg-success' : ''">
                    <div>
                      <b-row>
                        <b-col>
                          <b-button
                            v-on:click="
                              isSidebarActiveProcess = true;
                              deleteBarcode = temp;
                            "
                            size="sm"
                            variant="outline-light"
                          >
                            <Icon
                              icon="material-symbols:close"
                              width="25"
                              height="25"
                              v-b-tooltip.hover.bottom="$t('Delete')"
                              color="#ea5455"
                            />
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                    <grid-layout
                      :layout="temp.TemplateDefinitionValue"
                      :col-num="12"
                      :row-height="1"
                      :is-draggable="false"
                      :is-resizable="false"
                      :vertical-compact="true"
                      :use-css-transforms="true"
                    >
                      <grid-item
                        v-for="item in temp.TemplateDefinitionValue"
                        :key="`${temp.TemplateDefinitionId}-${item.i}`"
                        :i="item.i"
                        :x="item.x"
                        :y="item.y"
                        :w="item.w"
                        :h="item.h"
                      >
                        <span class="text" v-if="item.barcode">
                          <barcode
                            :value="item.barcode"
                            format="CODE128"
                            :text-options="{ fontSize: 8 }"
                            style="width: 100%; height: 100%; text-align: center"
                          />
                        </span>
                        <div
                          class="grid-item-content"
                          style="text-align: center; font-size: 6px"
                          v-else-if="item.label"
                        >
                          {{ item.label }}
                        </div>
                        <span class="text" v-else style="font-size: 6px"
                          >{{ item.item }}
                        </span>
                      </grid-item>
                    </grid-layout>
                  </vs-card>
                </b-col>
              </b-row>
            </component>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <vs-card>
              <b-row>
                <b-col>
                  <v-select
                    color="danger"
                    v-model="selectedBarcode"
                    :options="barcode_options"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="customer"
                    v-validate="'required'"
                    @input="getSelectedStockWithBarcode"
                  >
                  </v-select>
                </b-col>
                <b-col>
                  <v-select
                    color="danger"
                    v-model="selectedBarcodeMatch"
                    :options="barcodematch_options"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="customer"
                    v-validate="'required'"
                    @input="getSelectedStockWithBarcodeMatch"
                  >
                  </v-select>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('Width')"
                        class="vs-input--label pr-0 mr-0"
                        label-for="h-first-name"
                        style="font-weight: 600"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="width"
                        type="number"
                        class="w-full"
                        name="width"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('width')">{{
                        errors.first("width")
                      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('Height')"
                        class="vs-input--label pr-0 mr-0"
                        label-for="h-first-name"
                        style="font-weight: 600"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="height"
                        type="number"
                        class="w-full"
                        name="height"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('height')">{{
                        errors.first("height")
                      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <!--
							<b-col>
								<b-row>
									<b-col cols="4" align-self="center">
										<b-form-group
											:label="$t('Quantity')"
											class="vs-input--label pr-0 mr-0"
											label-for="h-first-name"
											style="font-weight: 600"
										>
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input
											size="small"
											v-model="quantity"
											type="number"
											class="w-full"
											name="quantity"
											v-validate="'required'"
										/>
										<span class="text-danger text-sm" v-show="errors.has('quantity')">{{
											errors.first("quantity")
										}}</span>
									</b-col>
								</b-row>
							</b-col>-->
              </b-row>
              <b-row>
                <b-row align-h="end">
                  <b-col lg="2">
                    <b-button
                      class="bg-primary mt-3"
                      style="border-color: white; width: 100%"
                      v-on:click="printBarcodeQty"
                    >
                      <Icon
                        icon="material-symbols:print-outline"
                        width="20"
                        height="20"
                      />
                      {{ $t("Print") }}</b-button
                    >
                  </b-col>
                </b-row>
              </b-row>
            </vs-card>
          </b-row>
          <b-row v-if="selectedTemp && findedStock">
            <div
              ref="printProductBarcode"
              :style="'width:' + width + 'px; height: ' + height + 'px'"
            >
              <vs-card :style="'width:' + width + 'px; height: ' + height + 'px'">
                <grid-layout
                  :layout="selectedTemp.TemplateDefinitionValue"
                  :col-num="12"
                  :row-height="10"
                  :is-draggable="false"
                  :is-resizable="false"
                  :vertical-compact="true"
                  :use-css-transforms="true"
                >
                  <grid-item
                    v-for="item in selectedTemp.TemplateDefinitionValue"
                    :key="`${selectedTemp.TemplateDefinitionId}-${item.i}`"
                    :i="item.i"
                    :x="item.x"
                    :y="item.y"
                    :w="item.w"
                    :h="item.h"
                  >
                    <span class="text" v-if="item.barcode">
                      <p style="text-align: center">
                        <barcode
                          v-if="barcodeMatchValidate"
                          :value="selectedBarcodeMatch"
                          format="CODE128"
                          :text-options="{ fontSize: 8 }"
                          style="width: 100%; height: 100%; text-align: center"
                        />
                        <barcode
                          v-else
                          :value="findedStock.barcode"
                          format="CODE128"
                          :text-options="{ fontSize: 8 }"
                          style="width: 100%; height: 100%; text-align: center"
                        />
                      </p>
                    </span>
                    <span
                      class="text"
                      style="text-align: center"
                      v-else-if="item.label"
                      :style="{ fontSize: item.fontSize + 'px' }"
                      ><p style="text-align: center">{{ item.label }}</p>
                    </span>
                    <span
                      class="text"
                      style="text-align: center"
                      v-else
                      :style="{ fontSize: item.fontSize + 'px' }"
                      ><p style="text-align: center" v-if="item.item == 'Date'">
                        {{ getToday() }}
                      </p>
                      <p style="text-align: center" v-else>
                        {{ findedStock.Stock[item.item] }}
                      </p>
                    </span>
                  </grid-item>
                </grid-layout>
              </vs-card>
            </div>
          </b-row>
        </b-col>
      </b-row>

      <vs-prompt
        :title="$t('Warning')"
        :acceptText="$t('Submit')"
        :cancelText="$t('Cancel')"
        @accept="deletesubmit"
        :active.sync="isSidebarActiveProcess"
        color="danger"
      >
        <div style="text-align: center" class="con-exemple-prompt">
          <span>
            <b-row style="margin-top: 15px">
              <b-col cols="12" align-self="center">
                <h6>{{ $t("DoConfirm") }}</h6>
              </b-col>
            </b-row>
          </span>
        </div>
      </vs-prompt>
    </vs-popup>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { GridLayout, GridItem } from "vue-grid-layout";

export default {
  components: {
    VuePerfectScrollbar,
    Icon,
    vSelect,
    GridLayout,
    GridItem,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      barcodeMatchValidate: false,
      barcode_options: [],
      barcodematch_options: [],
      templates: [],
      selectedBarcodeMatch: "",
      isSidebarActiveProcess: false,
      width: 0.0,
      height: 0.0,
      selectedBarcode: "",
      findedStock: [],
      selectedTemp: "",
    };
  },
  methods: {
    getBarcodeMatchingList() {
      const vs = this.$vs;
      this.barcode_options = [];
      this.$store
        .dispatch("stock/listStockMatching")
        .then((response) => {
          if (response.success == true) {
            try {
              let stockJson = JSON.parse(response.json);

              this.barcodematch_options = stockJson;
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printBarcodeQty() {
      const printContents = this.$refs.printProductBarcode.innerHTML;
      const originalContents = document.body.innerHTML;

      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print</title>");
      printWindow.document.write("</head><body >");
      printWindow.document.write(printContents);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
    deletesubmit() {
      const vs = this.$vs;
      this.$store
        .dispatch("template/deleteTemplate", this.deleteBarcode.TemplateDefinitionId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getTemplateList();
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSelectedTemplate(item, ind) {
      this.selectedTemp = item;
      this.width = this.selectedTemp.TemplateDefinitionWith;
      this.height = this.selectedTemp.TemplateDefinitionHeight;
      this.templates.forEach((val, index) => {
        this.templates[index].isSelected = "";
      });
      this.templates[ind].isSelected = "selected";
      this.mainLayout = this.selectedTemp.TemplateDefinitionValue;
    },
    getSelectedStockWithBarcodeMatch() {
      this.barcodeMatchValidate = true;
    },
    getSelectedStockWithBarcode() {
      this.barcodeMatchValidate = false;
      this.findedStock = this.stockWithBarcodes.find(
        (item) => item.StockBarcodeId == this.selectedBarcode.value
      );
    },
    closePrintPopup() {
      this.findedStock = [];
      this.selectedTemp = [];
      this.selectedBarcode = "";
      this.isSidebarActiveLocal = false;
      this.barcodeMatchValidate = false;
    },
    getStockWithBarcodesList() {
      const vs = this.$vs;
      this.barcode_options = [];
      this.$store
        .dispatch("stock/listStockWithBarcodes", this.printData.CompanyId)
        .then((response) => {
          if (response.success == true) {
            try {
              let stockJson = JSON.parse(response.json);
              let filteredData = stockJson.filter(
                (item) => item.Stock.StockId == this.printData.StockId
              );
              filteredData.forEach((val, index) => {
                this.barcode_options.push({
                  name: val.Barcode,
                  value: val.StockBarcodeId,
                });
              });
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTemplateList() {
      const vs = this.$vs;
      this.$store
        .dispatch("template/listTemplatesForCompany", this.data.CompanyId)
        .then((response) => {
          if (response.success == true) {
            try {
              let datas = JSON.parse(response.json);
              datas.forEach((val, index) => {
                let lcItem = JSON.parse(val.TemplateDefinitionValue);
                datas[index].TemplateDefinitionValue = lcItem;
                lcItem.forEach((value, ind) => {
                  datas[index].TemplateDefinitionValue[ind].i = datas[
                    index
                  ].TemplateDefinitionValue[ind].i.toString();

                  datas[index].TemplateDefinitionValue[ind].static = true;
                });
              });
              this.templates = datas;
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val == true) {
        this.getTemplateList();
        this.getStockWithBarcodesList();
      }
      return val;
    },
    data(val) {
      return val;
    },
  },
};
</script>
<!--
<style lang="scss">
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 210px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}

.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  cursor: pointer;
}
.vue-barcode-element {
  height: 100%;
  width: 100%;
}
.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 60px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.con-vs-dialog {
  z-index: 520055;
}

.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 210px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}

.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  cursor: pointer;
}
.vue-barcode-element {
  height: 100%;
  width: 100%;
}
.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 60px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.con-vs-dialog {
  z-index: 520055;
}
.vertical-line {
  width: 2px;
  height: 100%;
  background-color: #000;
  margin: 0 auto;
}
@media print {
  .vertical-line {
    width: 2px;
    height: 100%;
    background-color: #000;
    margin: 0 auto;
  }
}
</style>
-->
